/* eslint-disable */
import 'nodelist-foreach-polyfill';
import 'element-closest-polyfill';
import Swiper from 'swiper/dist/js/swiper'; // https://github.com/nolimits4web/Swiper/issues/2263
import 'swiper/dist/css/swiper.css';
import './vertical-slider.scss';
import scrollSlider from '../../../scroll-slider';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-vertical-slider-wrapper]').forEach((wrapper) => {
    const container = wrapper.querySelector('[data-vertical-slider-container]');
    const pagination = container.querySelector('.swiper-pagination');
    const nextEl = wrapper.querySelector('[data-next-el]');
    const prevEl = wrapper.querySelector('[data-prev-el]');

    const swiper = new Swiper(container, { // eslint-disable-line
      spaceBetween: 1,
      slidesPerView: 1,
      autoHeight: true,
      effect: 'fade',
      // allowTouchMove: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + '<i>' + (index + 1) + '</i>' + '</span>';
        }
      },
      navigation: {
        nextEl,
        prevEl,
      }
    });

    function prevAll(element) {
      let result = [];
      while (element = element.previousElementSibling)
        result.push(element);
      return result;
    }
    function nextAll(element) {
      let result = [];
      while (element = element.nextElementSibling)
        result.push(element);
      return result;
    }


    // const sliderWrapper = wrapper.closest('.vertical-slider-wrapper');
    // const section = wrapper.closest('section');
    // const target = window.innerHeight > section.clientHeight ? section : sliderWrapper;    

    // const setScrolling = scrollSlider(target, {
    //   length: swiper.slides.length, 
    //   onUpdate: index => swiper.slideTo(index),
    // });

    swiper.on('slideChange', function () {
      let activePage = pagination.querySelector('.swiper-pagination-bullet-active');

      let prevAllPages = prevAll(activePage);
      for (var i = 0; i < prevAllPages.length; i++) {
        prevAllPages[i].classList.add('pass')
      }

      let nextAllPages = nextAll(activePage);
      for (var i = 0; i < nextAllPages.length; i++) {
        nextAllPages[i].classList.remove('pass')
      }

      // setScrolling(swiper.activeIndex);
    });
  });
});
